// extracted by mini-css-extract-plugin
module.exports = {"root":"BottomNavigation_root__fqh7L","buttonFocusMotion":"BottomNavigation_buttonFocusMotion__skHik"};